import { AssetTransferLine } from './asset-transfer-line';
import { AssetOrder } from './asset-order';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';



export class AssetTransfer extends BaseEntity {

  assetTransferCode : string;
  assetTransferType : string;
  theDate           : Date;	
  progressLevel     : number
  role              : Role;
  person            : Person;
  fromBranch        : Branch;
  toBranch          : Branch;
  partner           : Partner;
  assetOrder        : AssetOrder;
  description       : string;
  receptionDate     : Date;
  rejecttionDate    : Date;
  rejectionNotes    : string;

  expeditionForecastDate : Date;
  assetTransferLines: AssetTransferLine[] = [];

  //-------------------------------------------
  expeditionModeEnabled    : boolean = true;
  receptionModeEnabled     : boolean = false;
  //--------------------------------------------

  constructor() {
    super();

  }
}

	
